export default function Steps({
  handlePrev,
  handleNext,
  textPrev,
  textNext,
  disableNext = false,
  backLabel = 'Voltar',
}) {
  return (
    <section className='d-flex flex-row justify-content-between mt-4 gap-2'>
      <button
        type='button'
        className='btn btn-outline-primary'
        onClick={handlePrev}
        aria-label={backLabel}
      >
        {textPrev}
      </button>
      <button
        type='button'
        className='btn btn-primary flex-grow-1 flex-sm-grow-0'
        style={{ minWidth: '10rem' }}
        onClick={handleNext}
        disabled={disableNext}
      >
        {textNext}
      </button>
    </section>
  );
}
